import classNames from 'classnames';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { tr } from '../../../../utils/translations/tr';
import { ApprovalOddsBadge } from '../../../ApprovalOddsBadge';
import type { ApprovalOddsLabels } from '../../../ApprovalOddsBadge';
import { TRANSLATIONS } from '../../i18n';
import { ChanceCardProps } from './types';

export const ChanceCard = ({ type, isFresh, showBorder }: ChanceCardProps) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  const config = {
    HIGH: {
      subtitle: tr('high_chance', staticText),
      description: tr('high_description', staticText),
      textColor: 'text-colors/supplementary-green-dark',
    },
    MEDIUM: {
      subtitle: tr('medium_chance', staticText),
      description: tr('medium_description', staticText),
      textColor: 'text-colors/supplementary-yellow-dark',
    },
    LOW: {
      subtitle: tr('low_chance', staticText),
      description: tr('low_description', staticText),
      textColor: 'text-colors/supplementary-orange-dark',
    },
    // "Not Available" is a product-side state (no odds configured), not a negative
    // credit signal — keep it visually neutral.
    UNKNOWN: {
      subtitle: tr('none_chance', staticText),
      description: tr('none_description', staticText),
      textColor: 'text-gray-700',
    },
  };

  const currentConfig = config[type];

  const labels: ApprovalOddsLabels = {
    high: tr('approval_odds_high', staticText),
    medium: tr('approval_odds_medium', staticText),
    low: tr('approval_odds_low', staticText),
    unlock: tr('approval_odds_unlock', staticText),
  };

  return (
    <div
      className={classNames(
        'flex flex-col gap-spacing/gap/soft-12px pb-spacing/gap/y',
        {
          'border-b border-borders/default': showBorder,
        },
      )}
    >
      <div
        className={classNames(
          'mhg-alpha-typography-title-2 flex flex-row items-center gap-spacing/gap/soft-12px',
          currentConfig.textColor,
        )}
      >
        <ApprovalOddsBadge
          isLocked={false}
          isFresh={isFresh}
          degree={type}
          labels={labels}
        />
        {currentConfig.subtitle}
      </div>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value -- inherited from main (ApprovalOdds); not in scope of CMS-1747 */}
      <div className="mhg-alpha-typography-body-2-relaxed text-[#424242]">
        {currentConfig.description}
      </div>
    </div>
  );
};
